import React, { Component } from "react"
import { Table, Row, message } from "antd"
import Moment from "moment"
import { observer, inject } from "mobx-react"
import recoveryIcon from "app/styles/images/sp/recovery.svg"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import FlexableFileName from "app/components/normal/FlexableFileName"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      showDeleteModal: false,
      dataSingle: {},
      editedHistory: []
    }

    this.columns = []
  }

  componentDidMount() {
    let { store: { getTableData, updateDataListData, initPageIndex } } = this.props
    getTableData()
      .then(
        res => {
          updateDataListData(res)
          initPageIndex()
        }
      )
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        getTableData,
        updateDataListData,
        updateQueryMap,
        queryMap
      },
      store
    } = this.props

    store.currentPageIndex = selectedPageNumber
    updateQueryMap({ offset: (selectedPageNumber - 1) * queryMap.limit })
    getTableData(queryMap)
      .then(
        res => {
          updateDataListData(res)
        }
      )
    document.getElementById("contentTop").scrollIntoView(true)
  }

  toggleHistory = (visible, record) => {
    if (visible) {
      // 获取数据
      const { getDataHistory } = this.props.store
      getDataHistory(record.id)
        .then(res => {
          this.setState({
            editedHistory: res
          })
        })
    } else {
      //清空拿到的数据
      this.setState({
        editedHistory: []
      })
    }
  }

  recoveryData = (record, index) => {
    const { store: { recoveryData, tableData } } = this.props

    recoveryData(record.id)
      .then(
        res => {
          tableData.splice(index, 1)
          message.success("数据恢复成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  render() {
    let {
      store: {
        tableData,
        totalCount,
        queryMap,
        currentPageIndex,
        selectedRecycle,
      },
    } = this.props

    this.columns = [
      {
        title: (
          <div className="ta-l">文件名称</div>
        ),
        width: "27.71%",
        dataIndex: "filename",
        render: (filename, record, index) => {
          const { queryMap: { keywords } } = this.props.store
          return <FlexableFileName filename={filename} keywords={keywords} isEqual={true} />
        }
      }, {
        title: (
          <div className="ta-l spe-title">数据样本名</div>
        ),
        dataIndex: "sampleName",
        width: "13.84%",
        render: (text, record) => {
          const { editedHistory } = this.state
          const { queryMap: { keywords } } = this.props.store
          const content = (
            <MaterialTip title={text}>
              <div className="ellipsis">
                <Highlighter
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={highlightable(text, keywords) ? [text] : []}
                  textToHighlight={text}
                />
              </div>
            </MaterialTip>
          )
          return (
            record.hasHistory
              ? <WarningTip
                type="warningTip"
                text={content}
                mainKeys={["versionNum", "sampleName", "createTime"]}
                historyData={editedHistory}
                onVisibleChange={(visible) => this.toggleHistory(visible, record)}
              />
              : <div>{content}</div>
          )
        }
      }, {
        title: (
          <div className="ta-r">数据大小</div>
        ),
        width: "11.2%",
        dataIndex: "size",
        render: text => {
          return text ? <div className="ta-r">{(text / 1024 / 1024).toFixed(2)}MB</div> : ""
        }
      }, {
        title: <div className="ta-c">上传时间</div>,
        dataIndex: "uploadTime",
        width: "16.41%",
        render: text => {
          return text ? <div className="ta-c">{Moment(text).format("YYYY-MM-DD HH:mm:ss")}</div> : ""
        }
      }, {
        title: <div className="ta-c">删除时间</div>,
        dataIndex: "deleteTime",
        width: "16.41%",
        render: text => {
          return text ? <div className="ta-c">{Moment(text).format("YYYY-MM-DD HH:mm:ss")}</div> : ""
        }
      }, {
        title: (
          <div className="ta-c">
            操作
          </div>
        ),
        dataIndex: "operator",
        width: 104,
        render: (text, record, index) => {
          return (
            <Row className="table-oprator" type="flex" justify="center" align="middle">
              <img
                title="恢复"
                src={recoveryIcon}
                className="cursor-p"
                alt=""
                onClick={() => this.recoveryData(record, index)}
              />
            </Row>
          )
        }
      }
    ]

    return (
      <div>
        <div
          className="wrapper-box"
          style={
            selectedRecycle === "data"
              ? {
                marginTop: 120
              }
              : {
                marginTop: 170
              }
          }
        >
          <Table
            className="recycle-data-table"
            columns={this.columns}
            rowKey={record => record.id + "store"}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          />
        </div>
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/pgs/recycleBin/containers/DataList.js